/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function ArrowLeftIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="m4.468 18.906 8.492-8.437a1.366 1.366 0 0 1 2.06 0 1.37 1.37 0 0 1 0 2.062L9.09 18.47h25.413a1.52 1.52 0 0 1 1.498 1.5c0 .875-.687 1.5-1.498 1.5l-25.413.062 5.932 5.938a1.37 1.37 0 0 1 0 2.062 1.367 1.367 0 0 1-2.061 0l-8.492-8.5c-.624-.562-.624-1.5 0-2.125"/>}
        </IconWrapper>);
}
